import firebase from 'firebase/app'
import {HTTP_API_V2} from '../../http-common'

export default {
  state: {
    loadedNuclei: [],
    loadedNucleiV2: []
  },
  getters: {
    loadedNuclei (state) {
      return state.loadedNuclei
    },
    loadedNucleiV2 (state) {
      return state.loadedNucleiV2
    },
    loadedNucleus (state) {
      return (nucleusId) => {
        return state.loadedNuclei.find(nucleus => {
          return nucleus.id === nucleusId
        })
      }
    },
    loadedNucleusV2 (state) {
      return (nucleusId) => {
        return state.loadedNucleiV2.find(nucleus => {
          return nucleus.id === nucleusId
        })
      }
    }
  },
  // synchronous
  mutations: {
    setNuclei (state, payload) {
      state.loadedNuclei = payload
    },
    setLoadNucleiV2 (state, payload) {
      state.loadedNucleiV2 = payload
    },
    createNucleus (state, payload) {
      state.loadedNuclei.push(payload)
    },
    updateNucleus ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const updateObj = {
        barns: payload.barns
      }
      const userId = firebase.auth().currentUser.uid
      return firebase.database().ref(userId + '/nuclei').child(payload.id).update(updateObj)
        .then(() => {
          commit('updateNucleus', payload)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    removeNucleus (state, payload) {
      let nuclei = state.loadedNuclei.filter(nucleus => {
        return nucleus.id !== payload.id
      })
      state.loadedNuclei = nuclei
    }
  },
  // asynchronous
  actions: {
    loadNuclei ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/nuclei').once('value')
        .then(data => {
          let nuclei = []
          const obj = data.val()
          for (let key in obj) {
            nuclei.push({
              id: key,
              description: obj[key].description,
              devices: obj[key].devices
            })
          }
          commit('setNuclei', nuclei)
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    loadNucleiV2 ({commit}) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('nuclei')
          .then(result => {
            const nucleus = result.data
              .filter(nuclei => nuclei.status === true)
              .map(nuclei => {
                return {
                  id: nuclei.id,
                  description: nuclei.description,
                  barns: nuclei.barns
                }
              })
            commit('setLoadNucleiV2', nucleus)
            resolve(nucleus)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err.message)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createNucleus ({ commit, getters }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const newNucleus = {
        description: payload.description,
        devices: payload.devices
      }
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/nuclei').push(newNucleus)
        .then(data => {
          commit('createNucleus', {
            ...newNucleus
          })
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    updateNucleus ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const updateObj = {}
      if (payload.description) {
        updateObj.description = payload.description
      }
      if (payload.devices) {
        updateObj.devices = payload.devices
      }
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/nuclei').child(payload.id).update(updateObj)
        .then(() => {
          commit('updateNucleus', payload)
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    removeNucleus ({ commit }, payload) {
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/nuclei').child(payload.id).remove()
        .then(() => {
          commit('removeNucleus', payload)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/nucleus/index.js